import _app from "../../../views/_app.tsx";
import _error from "../../../views/_error.tsx";

import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "_app": _app,
  "_error": _error,
  "archive-news": dynamic(() => import("../../../views/archive-news.tsx"), "views/archive-news.tsx"),
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "single-collection": dynamic(() => import("../../../views/single-collection.tsx"), "views/single-collection.tsx"),
  "single-film": dynamic(() => import("../../../views/single-film.tsx"), "views/single-film.tsx"),
  "single-news": dynamic(() => import("../../../views/single-news.tsx"), "views/single-news.tsx"),
  "single-venue": dynamic(() => import("../../../views/single-venue.tsx"), "views/single-venue.tsx"),
  "taxonomy-news-cats": dynamic(() => import("../../../views/taxonomy-news-cats.tsx"), "views/taxonomy-news-cats.tsx"),
  "template-browse-films": dynamic(
    () => import("../../../views/template-browse-films.tsx"),
    "views/template-browse-films.tsx",
  ),
  "template-collections": dynamic(
    () => import("../../../views/template-collections.tsx"),
    "views/template-collections.tsx",
  ),
  "template-home": dynamic(() => import("../../../views/template-home.tsx"), "views/template-home.tsx"),
  "template-news": dynamic(() => import("../../../views/template-news.tsx"), "views/template-news.tsx"),
  "template-search": dynamic(() => import("../../../views/template-search.tsx"), "views/template-search.tsx"),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
